module.exports = __webpack_public_path__ + "img/Chef.7932781.svg";